import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { FlashMessageProvider } from "./components/flashMessage/FlashMessageContext";
import MainApp from "./MainApp";
import { AuthProvider } from "./auth/AuthProvider";

const App: React.FC = () => {
  return (
    <FlashMessageProvider>
      <AuthProvider>
        <Router>
          <MainApp />
        </Router>
      </AuthProvider>
    </FlashMessageProvider>
  );
};

export default App;
